import { localDB } from './pouchdb-config';
import { fetchAllDocs } from './direct-couchdb';

const productService = {
  getAllProducts: async (includeInactive = false) => {
    try {
      let allDocs;
      try {
        allDocs = await fetchAllDocs();
      } catch (directError) {
        const timeoutPromise = new Promise((_, reject) => 
          setTimeout(() => reject(new Error('PouchDB timeout')), 10000)
        );
        const pouchPromise = localDB.allDocs({ include_docs: true });
        allDocs = await Promise.race([pouchPromise, timeoutPromise]);
      }
      
      // Ensure allDocs and allDocs.rows exist
      if (!allDocs || !allDocs.rows) {
        console.error('Invalid response from database:', allDocs);
        return [];
      }
      
      let products = allDocs.rows
        ?.map(row => row.doc)
        ?.filter(doc => doc && doc.type === 'product') || [];
      
      if (!includeInactive) {
        products = products.filter(product => product.active !== false);
      }
      
      return products;
    } catch (error) {
      console.error('Error getting products:', error);
      return []; // Always return empty array on error
    }
  },

  getProductById: async (id) => {
    try {
      return await localDB.get(id);
    } catch (error) {
      console.error(`Error getting product with ID ${id}:`, error);
      throw new Error('Failed to load product details');
    }
  },

  findProductsByCategory: async (category, includeInactive = false) => {
    try {
      // Get all products first
      const allProducts = await productService.getAllProducts(includeInactive);
      
      // Filter by category
      return allProducts.filter(product => product.category === category);
    } catch (error) {
      console.error(`Error finding products in category ${category}:`, error);
      return [];
    }
  },
  
  findProductsByPriceRange: async (minPrice, maxPrice, includeInactive = false) => {
    try {
      // Get all products first
      const allProducts = await productService.getAllProducts(includeInactive);
      
      // Filter by price range
      return allProducts.filter(product => {
        const price = product.pricing?.USD || product.price || 0;
        return price >= minPrice && price <= maxPrice;
      });
    } catch (error) {
      console.error(`Error finding products in price range:`, error);
      return [];
    }
  }
};

export default productService;